// Non-sensitive UI preferences for Dice (mute flag, last bet, last selected
// number). Backed by the shared namespaced preference store, which uses
// localStorage with a safe in-memory fallback. NEVER stores tokens, balances,
// or any server-authoritative data.
import { createPreferences, DEFAULT_BET_MINOR } from '@aerofruits/game-shell';

export interface DicePreferences {
  muted: boolean;
  betMinor: number;
  /** Last picked number 1..6, or null when the player has never picked one. */
  selectedNumber: number | null;
  /** User-selected UI locale (BCP-47 tag); null = follow launch/browser. */
  locale: string | null;
}

const store = createPreferences('lightning-dice');

const KEY_MUTED = 'muted';
const KEY_BET = 'bet';
const KEY_SELECTED = 'selected';
const KEY_LOCALE = 'locale';

export function loadPreferences(): DicePreferences {
  // 0 is the "absent" sentinel: the player starts with NO number selected so the
  // Roll button is disabled until they choose one. A previously persisted, valid
  // face is restored; anything else is treated as no selection.
  const selected = store.getInt(KEY_SELECTED, 0);
  return {
    muted: store.getBoolean(KEY_MUTED, false),
    betMinor: store.getInt(KEY_BET, DEFAULT_BET_MINOR),
    selectedNumber: selected >= 1 && selected <= 6 ? selected : null,
    locale: store.getString(KEY_LOCALE),
  };
}

export function savePreferences(prefs: DicePreferences): void {
  store.setBoolean(KEY_MUTED, prefs.muted);
  store.setInt(KEY_BET, prefs.betMinor);
  if (prefs.selectedNumber !== null) store.setInt(KEY_SELECTED, prefs.selectedNumber);
  if (prefs.locale) store.setString(KEY_LOCALE, prefs.locale);
  else store.remove(KEY_LOCALE);
}
